export default "__VITE_ASSET__nDeT_pd3__"